<template>
  <div>
    
      <h3>Lesson content here.</h3>
      <div>
        <button @click="goOn" variant="primary">Read More</button>
      </div>
      
      <div v-if="!message.options.preventSkip">
            <button @click="goOn" variant="primary">Skip</button>
          </div>
    </div>
</template>

<script>
import { Message } from '@/bot-engine.es5.js'

export default {
  props: {
    message: {
      type: Message
    }
  },
  computed: {
    imageSource() {
      return "https://picsum.photos/600/300/?image=" + Math.floor((Math.random() * 25) + 1)
    }
  },
  methods: {
    goOn() {
      this.$emit("next");
    }
  }
}
</script>

<style scoped>
</style>
